import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";

class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accounts: "NA",
      spinnerClass: "",
      dataClass: "collapse"
    };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +   "/account/chequeReport",
        this.props.data
      )
      .then(res => {
        this.setState({
          accounts: res.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      });
  }

  tabHeader() {
    return (
      <tr>
        <th className="border p-1 font-weight-bold" width="120px">
          Txn Date
        </th>
        <th className="border p-1 font-weight-bold" width="300px">
          Bank
        </th>
        <th className="border p-1 font-weight-bold" width="150px">
          Cheque Date
        </th>
        <th className="border p-1 font-weight-bold" width="200px">
          Cheque Amount
        </th>
        <th className="border p-1 font-weight-bold" width="300px">
          Cheque Bank
        </th>
      </tr>
    );
  }

  tabRow() {
    if (this.state.accounts != "NA") {
      return this.state.accounts.map(function(obj) {
        if (
          obj.chdate !== null &&
          obj.chdate !== "" &&
          obj.chdate !== undefined
        ) {
          var arrExpDate = obj.chdate.split("-");
          var chdate =
            arrExpDate[2].substring(0, 2) +
            "-" +
            arrExpDate[1] +
            "-" +
            arrExpDate[0];
        }

        if (
          obj.txndate !== null &&
          obj.txndate !== "" &&
          obj.txndate !== undefined
        ) {
          var arrTxnDate = obj.txndate.split("-");
          var txndate =
            arrTxnDate[2].substring(0, 2) +
            "-" +
            arrTxnDate[1] +
            "-" +
            arrTxnDate[0];
        }

        var amtParts = obj.chAmount.toString().split(".");
        var amt =
          amtParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (amtParts[1] ? "." + amtParts[1] : ".00");

        return (
          <tr key={obj._id}>
            <td className="border p-1">{txndate}</td>
            <td className="border p-1 text-wrap">{obj.bankName}</td>
            <td className="border p-1">{chdate}</td>
            <td className="border p-1">{obj.chAmount}</td>
            <td className="border p-1">{obj.chBank}</td>
          </tr>
        );
      });
    }
  }

  DisplayFilter() {
    return "Status - " + this.props.data.status;
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Cheque Details</h3>
        <h5 align="center"> {this.DisplayFilter()}</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>{this.tabHeader()}</thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default Account;
